import { Button, Group, Input } from '@mantine/core'
import { SyntheticEvent, useState } from 'react'

import { Search } from 'src/common/components/ui/Icons/Icons'

type Props = {
  searchEnrollmentChecker: (searchTerm: string) => void
}

const SEARCH_TERM_MIN = 2
const REGEX = /[!-\/:-@[-`{-~]/g

const SearchForm = ({ searchEnrollmentChecker }: Props) => {
  const [searchTerm, setSearchTerm] = useState('')

  const handleChange = (search: string) => {
    const sanatizedValue = search.replaceAll(REGEX, '')
    setSearchTerm(sanatizedValue)
  }

  const onSubmit = (e: SyntheticEvent) => {
    e.preventDefault()
    searchEnrollmentChecker(searchTerm)
    setSearchTerm('')
  }
  return (
    <form onSubmit={onSubmit}>
      <Group mt="lg" justify="center">
        <Input
          value={searchTerm}
          py="sm"
          w={380}
          onChange={({ target: { value } }) => handleChange(value)}
          placeholder="Search by TLC, driver's license or phone number"
          leftSection={<Search size={16} />}
        />
        <Button
          disabled={searchTerm.length < SEARCH_TERM_MIN}
          type="submit"
          variant="filled"
        >
          Search
        </Button>
      </Group>
    </form>
  )
}

export default SearchForm
